import React, { useState } from "react";
import { Mail, Phone, Linkedin, Facebook, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

const Footer = () => {
  const [email, setEmail] = useState("");

  const currentYear = new Date().getFullYear();

  const phoneNumber = process.env.NEXT_PUBLIC_PHONE_NUMBER;

  return (
    <footer className={styles.footerContainer}>
      <div className={styles.newsletterSection}>
        <h3 className={styles.newsletterTitle}>Restez connectés</h3>
        <h2 className={styles.newsletterSubtitle}>
          Inscrivez-vous pour recevoir les dernières nouvelles
        </h2>
        <p className={styles.newsletterDescription}>
          Ne manquez rien des avancées et des opportunités dans le secteur de
          l’élevage au Sénégal.
        </p>
        <div className={styles.newsletterForm}>
          <input
            type="email"
            placeholder="Je laisse mon email"
            className={styles.newsletterInput}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button className={styles.subscribeButton}>Je m’abonne</button>
        </div>
      </div>

      <hr className={styles.footerDivider} />

      <div className={styles.footerBottom}>
        <div className={styles.footerBrand}>
          <img
            src="/assets/images/logo_jourgui.png"
            alt="Jourgui Logo"
            className={styles.footerLogo}
          />
          <h3 className={styles.footerBrandText}>JOURGUI</h3>
        </div>

        <ul className={styles.footerLinks}>
          <li>
            <Link to="/">Accueil</Link>
          </li>
          <li>
            <Link to="/chiffres-analyses">Chiffres et analyses</Link>
          </li>
          <li>
            <Link to="/services">Services</Link>
          </li>
          <li>
            <Link to="/actu">Actualités</Link>
          </li>
        </ul>

        <div className={styles.footerContact}>
          <div className={styles.contactItem}>
            <Phone className={styles.contactIcon} />
            <p>{phoneNumber}</p>
          </div>
          <div className={styles.contactItem}>
            <Mail className={styles.contactIcon} />
            <p>info@jourgui.sn</p>
          </div>
        </div>

        <div className={styles.footerSocials}>
          <Linkedin className={styles.socialIcon} />
          <Facebook className={styles.socialIcon} />
          <Instagram className={styles.socialIcon} />
        </div>
      </div>

      <p className={styles.footerCopyright}>
        © {currentYear} Jourgui, Tous droits réservés
      </p>
    </footer>
  );
};

export default Footer;
